import { Routes } from '@angular/router';

import { authGuard, guestGuard, minimumRoleGuard, featureFlagGuard } from './core/auth';
import { AppShellComponent, LoginPageComponent } from './core/layout';
import { StockPage } from './features/stock/stock.page';

export const appRoutes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    component: LoginPageComponent
  },
  {
    path: '',
    canActivate: [authGuard],
    component: AppShellComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: StockPage
      },
      {
        path: 'catalog',
        canActivate: [minimumRoleGuard('STORE_ADMIN')],
        loadChildren: () => import('./features/catalog/catalog.routes').then((m) => m.CATALOG_ROUTES)
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then((m) => m.USERS_ROUTES)
      },
      {
        path: 'management',
        loadChildren: () => import('./features/management/management.routes').then((m) => m.MANAGEMENT_ROUTES)
      },
      {
        path: 'custom-attributes',
        canActivate: [minimumRoleGuard('STORE_ADMIN')],
        loadChildren: () => import('./features/custom-attributes/custom-attributes.routes').then((m) => m.CUSTOM_ATTRIBUTES_ROUTES)
      },
      {
        path: 'suppliers',
        loadChildren: () => import('./features/suppliers/suppliers.routes').then((m) => m.SUPPLIERS_ROUTES)
      },
      {
        path: 'stores',
        loadChildren: () => import('./features/stores/stores.routes').then((m) => m.STORES_ROUTES)
      },
      {
        path: 'business-settings',
        canActivate: [minimumRoleGuard('SUPER_ADMIN')],
        loadChildren: () => import('./features/business-settings/business-settings.routes').then((m) => m.BUSINESS_SETTINGS_ROUTES)
      },
      {
        path: 'transfers',
        loadChildren: () => import('./features/transfers/transfers.routes').then((m) => m.TRANSFERS_ROUTES)
      },
      {
        path: 'sales-channels',
        canActivate: [minimumRoleGuard('SUPER_ADMIN'), featureFlagGuard('sales-channels.wix')],
        loadChildren: () => import('./features/sales-channels/sales-channels.routes').then((m) => m.SALES_CHANNELS_ROUTES)
      },
      {
        path: 'stock',
        pathMatch: 'full',
        redirectTo: '/'
      },
      {
        path: 'reports',
        canActivate: [minimumRoleGuard('SUPER_ADMIN'), featureFlagGuard('reports.sales-export')],
        loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES)
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
